import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export function useActiveBreakpoint() {
  const theme = useTheme();
  const breakpoints = theme.breakpoints.keys;
  let active;

  for (const bp of [...breakpoints].reverse()) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (useMediaQuery(theme.breakpoints.only(bp))) {
      active = bp;
    }
  }
  return active || "xs";
}
